module.exports = __webpack_public_path__ + "img/dis-icon3.ac3d7a38.png";